export default "__VITE_ASSET__pUmygLD5__"